import React from 'react'
import { ProductImagePlaceholder } from './.'
import PropTypes from 'prop-types'
import ImageGallery from 'react-image-gallery'
import ReactPlaceholder from 'react-placeholder'
import MediaQuery from 'react-responsive'
import WishlistHeart from 'Wishlist/WishlistHeart'
import 'react-image-gallery/styles/css/image-gallery.css'

const ProductImage = ({ isLoading, isVoucher, images, imageUrl, sku }) => (
  <ReactPlaceholder
    ready={!isLoading}
    customPlaceholder={<ProductImagePlaceholder voucher={isVoucher} />}
  >
    <div className={`product-image overflow ${!images ? 'voucher' : ''}`}>
      <WishlistHeart sku={sku} />
      <MediaQuery maxDeviceWidth={767}>
        <ImageGallery
          showPlayButton={false}
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showNav={false}
          showBullets
          showThumbnails={false}
          items={images
            ? images.map(img => ({
              original: img.largeImage || img.mediumImage,
              thumbnail: img.smallImage,
              thumbnailClass: 'radius mt-2',
              originalAlt: sku,
              thumbnailAlt: sku
            }))
            : [{ original: imageUrl, thumbnail: imageUrl }]
          }
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={768}>
        <ImageGallery
          showPlayButton={false}
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showNav={false}
          showThumbnails={!!(images && images.length > 1)}
          items={images
            ? images.map(img => ({
              original: img.largeImage || img.mediumImage,
              thumbnail: img.smallImage,
              thumbnailClass: 'radius mt-2',
              originalAlt: sku,
              thumbnailAlt: sku
            }))
            : [{ original: imageUrl, thumbnail: imageUrl }]
          }
        />
      </MediaQuery>
    </div>
  </ReactPlaceholder>
)

ProductImage.propTypes = {
  isLoading: PropTypes.bool,
  isVoucher: PropTypes.bool,
  images: PropTypes.array,
  imageUrl: PropTypes.string,
  sku: PropTypes.string
}

export default ProductImage



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/DetailSection/ProductImage/ProductImage.js